/**
 * Returns a stable UTC epoch-day key (ms since Unix epoch at 00:00:00 UTC for the date's day).
 * Uses UTC getters to avoid timezone-dependent drift between environments.
 */
export function utcEpochDayKey(date: Date): string {
  return String(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
}

/**
 * Numeric variant of utcEpochDayKey for internal dedupe Sets/Maps when needed.
 */
export function utcEpochDayKeyNumber(date: Date): number {
  return Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
}


